import cx from 'clsx';

import { InputOverrideClassNames } from '../textinput';
import { InputStyleProps } from '../types';

import fileInputClasses from './FileInput.module.css';

export const FileInputOverrideClassnames = (props: InputStyleProps) => {
  const { size, error, rightSection } = props;

  const classes = InputOverrideClassNames({ size, error, rightSection });

  return {
    ...classes,
    input: cx(classes.input, fileInputClasses.input)
  };
};
